import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-bui-card',
  templateUrl: './bui-card.component.html',
  styleUrls: ['./bui-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuiCardComponent {
  @Input() title: string;
}
